import { useMemo } from "react";
import _ from "lodash";
import { addQueryParam } from "helpers/query-helpers";

export const get360Source = (asset: { url: string; image_ids?: string[] }, maxWidth?: string | number) =>
    asset
        ? _.map(asset.image_ids, (id) =>
              addQueryParam(asset.url, { image_id: id }, maxWidth && { max_width: maxWidth })
          )
        : [];

export const use360Source = (asset: { url: string; image_ids?: string[] }, maxWidth?: string | number) => {
    return useMemo(() => get360Source(asset, maxWidth), [asset, maxWidth]);
};

export default use360Source;
